<template>
  <a-select
    showSearch
    labelInValue
    :value="value"
    :placeholder="$t('business.placeholder.pleaseSelect')"
    style="width: 100%"
    :filterOption="filterOption"
    @search="fetchOption"
    @change="handleChange"
    :allowClear="allowClear"
    :notFoundContent="fetching ? undefined : null"
  >
    <a-spin v-if="fetching" slot="notFoundContent" size="small" />
    <a-select-option v-for="d in data" :key="d.value">{{ d.text }}</a-select-option>
  </a-select>
</template>
<script>
  import debounce from 'lodash/debounce'
  //import { getDictionary } from '../../../api/common/method'
  import { mapActions } from 'vuex'
  import store from '@/store'
  import { WAREHOUSE } from '@/store/mutation-types'

  export default {
    name: 'Dictionary',
    data() {
      this.fetchOption = debounce(this.fetchOption, 800)
      return {
        data: [],
        value: '',
        fetching: false,
        dictionaryOrdinal: '',
        dictionaryObject: {},
        lastFetchId: 0,
      returnData: {},
      allowClear: true
    }
  },
  props: {
    paramId: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ''
    },
    dictionary:{
      type: Boolean,
      default: false
    },
    whId: {
      type: String,
      default:''
    }
  },
  mounted () {
    const _this = this
    this.fetchOption(_this)
    this.$emit('getDictionaryData')
  },
  methods: {
    ...mapActions(['GetDictionary','SetDictionary']),
    fetchOption (_this) {
      this.lastFetchId += 1
      const fetchId = this.lastFetchId
      this.data = []
      this.fetching = true
      const whId = (Vue.ls.get(WAREHOUSE)).id
      const fields = store.getters.fields
      console.log(fields,'store.getters.fields')
      let dataFields = []
      if(fields.get(_this.title)){
        const field =fields.get(_this.title)
        if(this.dictionary){
          dataFields = field.map(t => ({
            text: t.name,
            value: t.id
          }))
        }else{
          dataFields = field.map(t => ({
            text: t.name,
            value: t.ordinal
          }))
        }

        this.data = dataFields
        this.returnData.key = this.data[0].value
        this.returnData.lable = this.data[0].text
        this.returnData.no = _this.paramId
      }else{
        const {
          GetDictionary,
          SetDictionary
        } = this
        console.log(whId, 'whId')
        console.log(_this.title, 'title')
        const parameter = {
          fieldNo : _this.title,
          lang : 'CH',
          whId : whId
        }
        GetDictionary(parameter)
          .then(res => {
            dataFields = res.map(t => ({
              text: t.name,
              value: t.ordinal
            }))
            fields.set(_this.title,res)
            console.log(fields,'fields')
            SetDictionary(fields)
            this.data = dataFields
            this.returnData.key = this.data[0].value
            this.returnData.lable = this.data[0].text
            this.returnData.no = _this.paramId
          })
      }
    },
    handleChange (value) {
      this.fetchOption(this)
      Object.assign(this, {
        value,
        data: [],
        fetching: false
      })
      this.dictionaryOrdinal = this.value.key
      this.dictionaryObject = { ordinal: this.value.key, name: this.value.label }

      //用于枚举选框在反复选择或者clear之后的赋值
      const fieldName=this.title[0].toLowerCase()+this.title.substring(1, this.name.length)
      const returnData={}
      returnData[fieldName]=value.key
      this.$emit('valueChange',returnData)
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>
